<template>
  <!-- Footer-->
  <footer class="footer footer-alt">
    <p class="text-muted">2018 - {{ year }} © PacSortOnline</p>
  </footer>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  setup() {
    const year = computed(() => new Date().getFullYear())

    return {
      year,
    }
  },
})
</script>
